import React from "react";

const MyRecordsBloodGroup = () => {
  return (
    <div className="patient-details_first-section">
      <h3>Blood Group</h3>
      <span className="blood-group_input"></span>
    </div>
  );
};

export default MyRecordsBloodGroup;
